import { render } from "./PersonaDropdown.vue?vue&type=template&id=4c08660f&scoped=true"
import script from "./PersonaDropdown.vue?vue&type=script&lang=js"
export * from "./PersonaDropdown.vue?vue&type=script&lang=js"

import "./PersonaDropdown.vue?vue&type=style&index=0&id=4c08660f&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c08660f"]])

export default __exports__